import styled, { css } from 'styled-components';

import { defaultThemeProp } from '../../theme';

export const StyledPopoverArrow = styled.div(
  ({
    theme: {
      base: {
        shadow: { 'low-filter': low }
      }
    }
  }) => css`
    background-color: inherit;
    height: 0;
    width: 0;
    filter: ${low};
    z-index: -1; /* Make sure it's under the Popover. */

    ::after {
      content: '';
      display: block;
      background-color: inherit;
      height: 0.5rem;
      width: 0.5rem;
      transform: rotate(45deg);
    }
  `
);

StyledPopoverArrow.defaultProps = defaultThemeProp;

export const StyledPopover = styled.div<{ offset?: number }>(
  ({
    theme: {
      base: {
        'border-radius': borderRadius,
        'z-index': { popover: zIndex },
        shadow: { 'low-filter': low }
      },
      components: {
        card: { background, 'border-radius': cardBorderRadius }
      }
    },
    offset
  }) => {
    return css`
      /*
        Margin should never be used with Popper.
        https://popper.js.org/docs/v2/migration-guide/#4-remove-all-css-margins
      */
      margin: 0 !important;
      z-index: ${zIndex};
      background-color: ${background};
      border-radius: calc(${cardBorderRadius} / 2);

      ::after {
        content: '';
        background-color: inherit;
        border-radius: inherit;
        z-index: -2; /* Make sure it's under the arrow. */
        filter: ${low};
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      &[data-popper-reference-hidden='true'] {
        visibility: hidden;
        pointer-events: none;
      }

      &[data-popper-placement^='top'] {
        > ${StyledPopoverArrow} {
          top: calc(100% - 0.25rem);
          margin-inline-start: -0.25rem;

          ::after {
            border-bottom-right-radius: calc(${borderRadius} / 4);
          }
        }

        ::before {
          content: '';
          position: absolute;
          height: ${offset}px;
          bottom: -${offset}px;
          left: 0;
          right: 0;
        }
      }

      &[data-popper-placement^='bottom'] {
        > ${StyledPopoverArrow} {
          bottom: calc(100% + 0.25rem);
          margin-inline-start: -0.25rem;

          ::after {
            border-top-left-radius: calc(${borderRadius} / 4);
          }
        }

        ::before {
          content: '';
          position: absolute;
          height: ${offset}px;
          top: -${offset}px;
          left: 0;
          right: 0;
        }
      }

      &[data-popper-placement^='right'] {
        > ${StyledPopoverArrow} {
          inset-inline-end: calc(100% + 0.25rem);
          margin-block-start: -0.25rem;

          ::after {
            border-bottom-left-radius: calc(${borderRadius} / 4);
          }
        }

        ::before {
          content: '';
          position: absolute;
          width: ${offset}px;
          left: -${offset}px;
          top: 0;
          bottom: 0;
        }
      }

      &[data-popper-placement^='left'] {
        > ${StyledPopoverArrow} {
          left: calc(100% - 0.25rem);
          margin-block-start: -0.25rem;

          ::after {
            border-top-right-radius: calc(${borderRadius} / 4);
          }
        }

        ::before {
          content: '';
          position: absolute;
          width: ${offset}px;
          right: -${offset}px;
          top: 0;
          bottom: 0;
        }
      }
    `;
  }
);

StyledPopover.defaultProps = defaultThemeProp;
